module.exports = __webpack_public_path__ + "img/green-check.e805aa88.svg";